// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"m5-z","dimensionLabel":"n5-z","styleChooserControlWrapper":"o5-z","styleChooserControl":"p5-z","disabled":"q5-z","giftCard":"r5-z","styleChooserText":"s5-z"};